import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CryptoJsService } from '../services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class OwnMiFarmerGuardGuard implements CanActivate {

  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //If token data exist, user may login to application
    const encData = sessionStorage.getItem('dataF') ? JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF'))) : null;
    const farmerConfData = encData ? new Map(encData) : new Map();
    let isOwnMIFarmer = farmerConfData.get('isOwnMIFarmerLogin') ? farmerConfData.get('isOwnMIFarmerLogin') : '';

    if (sessionStorage.getItem('token') && isOwnMIFarmer === '1') {
      return true;
    } else {
      this.router.navigate(['/tubewell-connection-login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
}
